'use client';

import React from "react";

export type TermLyProps = {
    id: string;
}

export default function PolicyFrame(props: TermLyProps) {

    React.useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <div
            name="termly-embed"
            data-id={props.id}
            data-type="iframe"
        ></div>
    );
}